import { createAction, props } from '@ngrx/store';
import { LightUserModel } from '../../../shared/data/models/light-user.model';
import { FollowUnFollowUserInput } from '../../../shared/data/inputs/follow-un-follow-user.input';
import { PeopleToFollowInput } from '../../../shared/data/inputs/people-to-follow.input';

export const loadPeopleToFollowMini = createAction(
  '[PeopleToFollow] Load people to follow mini',
  props<{ input?: PeopleToFollowInput }>()
);

export const loadPeopleToFollowMiniSuccess = createAction(
  '[PeopleToFollow] Load people to follow mini success',
  props<{ users: LightUserModel[] }>()
);

export const loadPeopleToFollowError = createAction(
  '[PeopleToFollow] Load people to follow error',
  props<{ error: string }>()
);

// follow actions

export const followSuggestedPerson = createAction(
  '[PeopleToFollow] follow Suggested Person',
  props<{ input: FollowUnFollowUserInput }>()
);

export const unFollowSuggestedPerson = createAction(
  '[PeopleToFollow] un follow suggested person',
  props<{ input: FollowUnFollowUserInput }>()
);

export const suggestedPersonError = createAction(
  '[PeopleToFollow] suggestedPersonError',
  props<{ followeeId: string; error: string }>()
);

export const suggestedPersonSuccess = createAction(
  '[PeopleToFollow] suggestedPersonSuccess',
  props<{ followeeId: string; followed: boolean }>()
);
